import {createRoot} from 'react-dom/client';
import FooterSocialLinks from './components/FooterSocialLinks';
import './App.css';
import './socialOpacity.css';

function mountSocialLinks() {
  const footer = document.querySelector('footer');
  if (!footer || footer.querySelector('[data-vicinity-social-links]')) return false;

  const slot = document.createElement('div');
  slot.dataset.vicinitySocialLinks = '';
  slot.style.cssText = 'width:100%;display:flex;justify-content:center;margin-bottom:12px;';
  footer.insertBefore(slot, footer.firstChild);
  createRoot(slot).render(<FooterSocialLinks />);
  return true;
}

if (!mountSocialLinks()) {
  const observer = new MutationObserver(() => {
    if (mountSocialLinks()) observer.disconnect();
  });
  observer.observe(document.getElementById('root'), {childList: true, subtree: true});
}